module.exports = __webpack_public_path__ + "static/media/poster-460.b152fb7e.jpg";